import {httpService} from "./api-service";
// import {router} from "./router";

class LanguageService {
    currentLang = 'en'
    switchLanguage() {
    }
    correctUrl() {

    }
    determineLanguage() {
        this.currentLang =
            window.localStorage.getItem("lang") ||
            this.getLangFromBrowser() ||
            "de";
    }
    private getLangFromBrowser() {
        const lang = navigator.language.split("-")[0];
        return ["en", "de"].includes(lang) ? lang : null;
    }

    changeLanguage(lang, router) {
        this.currentLang = lang;
        window.localStorage.setItem("lang", lang);
        const uri = router.current.path;
        const uriParts = uri.split("/");
        // immutable versions of splice and unshift
        const newUri = ["en", "de"].includes(uriParts[1])
            ? [...uriParts.slice(0,1), lang, ...uriParts.slice(2)]
            : [...uriParts.slice(0,1), lang, ...uriParts.slice(1)];
        window.location.href = newUri.join('/')
    }

    addHeaderInterceptor() {
        httpService.addInterceptor()
    }
}

export const languageService = new LanguageService();
